import { message, Select } from 'antd';
import { Button, Form, Input, Space } from 'antd';
import {
  Button as ButtonMobile,
  Form as FormMobile,
  Input as InputMobile,
} from 'antd-mobile';
import { useEffect, useRef, useState } from 'react';
import { useUserAgentInfo } from '../../context/user-agent';
import { phoneNumberValidator } from '../../utils/common';
import request from '../../utils/request/next-request';
import Styles from './index.mobile.module.scss';
const { Option } = Select;

const CaptchaFormPc = ({ time, sendCaptcha }) => {
  const prefixSelector = (
    <Form.Item name="AreaCode" noStyle>
      <Select style={{ width: 94, textAlign: 'left' }}>
        <Option value="86">+86</Option>
      </Select>
    </Form.Item>
  );
  return (
    <>
      <Form.Item
        name="PhoneNumber"
        label="联系方式"
        rules={[
          { validator: phoneNumberValidator() },
          { required: true, message: '请输入联系方式', whitespace: true },
        ]}
      >
        <Input
          placeholder="请输入手机号"
          addonBefore={prefixSelector}
          maxLength={11}
          style={{ width: 400 }}
        />
      </Form.Item>
      <Form.Item
        name="ValidateCode"
        label="验证码"
        rules={[{ required: true, message: '请输入验证码', whitespace: true }]}
      >
        <Space size="middle">
          <Input
            style={{ width: '283px' }}
            placeholder="请输入验证码"
            maxLength={6}
          />
          <Button
            type="primary"
            onClick={() => sendCaptcha()}
            className={Styles.button}
            disabled={time > 0}
          >
            获取验证码{time > 0 && `(${time})`}
          </Button>
        </Space>
      </Form.Item>
    </>
  );
};

const CaptchaFormMobile = ({ time, sendCaptcha }) => {
  const prefixSelector = (
    <FormMobile.Item name="AreaCode" noStyle>
      <Select style={{ width: 94, textAlign: 'left' }}>
        <Option value="86">+86</Option>
      </Select>
    </FormMobile.Item>
  );
  return (
    <>
      <FormMobile.Item
        className={Styles.formList}
        name="PhoneNumber"
        label="联系方式"
        validateTrigger="onblur"
        rules={[
          { validator: phoneNumberValidator() },
          { required: true, message: '请输入联系方式', whitespace: true },
        ]}
      >
        <InputMobile
          placeholder="请输入手机号"
          type="number"
          pattern="[0-9]*"
        />
      </FormMobile.Item>
      <FormMobile.Item
        className={Styles.formList}
        name="ValidateCode"
        label="验证码"
        layout="horizontal"
        rules={[{ required: true, message: '请输入验证码', whitespace: true }]}
        extra={
          <ButtonMobile
            onClick={() => sendCaptcha()}
            disabled={time > 0}
            color="primary"
          >
            获取验证码{time > 0 && `(${time})`}
          </ButtonMobile>
        }
      >
        <InputMobile placeholder="请输入验证码" maxLength={6} />
      </FormMobile.Item>
    </>
  );
};

const CaptchaForm = ({ form, afterSendCaptcha = null }) => {
  const [time, setTime] = useState(0);

  const { isMobile } = useUserAgentInfo();

  let timer = useRef(null);
  useEffect(() => {
    if (time === 60)
      timer.current = setInterval(() => setTime((t) => t - 1), 1000);
    else if (time === 0) clearInterval(timer.current);
  }, [time]);

  const sendCaptcha = async () => {
    const data = await form.validateFields(['AreaCode', 'PhoneNumber']);
    data['AreaCode'] ??= '+86';
    const res = await request({
      url: `${process.env.NEXT_PUBLIC_API_BASE_URL}/send-captcha`,
      method: 'post',
      data,
    });
    if (res) {
      setTime(60);
      message.success('验证码已发送！');
    } else {
      message.error('请重试！');
    }
    // 发送验证码后钩子事件
    afterSendCaptcha && afterSendCaptcha();
  };

  const params = {
    time,
    sendCaptcha,
  };

  return isMobile ? (
    <CaptchaFormMobile {...params} />
  ) : (
    <CaptchaFormPc {...params} />
  );
};

export default CaptchaForm;
